<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
  import './assets/scss/element-variables.scss';
  import './assets/scss/default.scss';
  import './assets/scss/cover.scss';
export default {
  name: 'App',
  provide(){
    return{
      reload: this.reload,
    }
  },
  data(){
    return{
      isRouterAlive: true,
    }
  },
  mounted() {
    this._elImageViewerMo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (
            n.nodeType === 1 &&
            n.classList &&
            n.classList.contains("el-image-viewer__wrapper")
          ) {
            this.$nextTick(() => this.bindImageViewerClosePosition(n));
          }
        });
        m.removedNodes.forEach((n) => {
          if (
            n.nodeType === 1 &&
            n.classList &&
            n.classList.contains("el-image-viewer__wrapper")
          ) {
            this.unbindImageViewerClosePosition(n);
          }
        });
      });
    });
    this._elImageViewerMo.observe(document.body, { childList: true });
    this._onWinResizeSyncImageViewerClose = () => {
      const w = document.querySelector(".el-image-viewer__wrapper");
      if (w) this.syncImageViewerClosePosition(w);
    };
    window.addEventListener("resize", this._onWinResizeSyncImageViewerClose);
  },
  beforeDestroy() {
    if (this._elImageViewerMo) {
      this._elImageViewerMo.disconnect();
      this._elImageViewerMo = null;
    }
    window.removeEventListener("resize", this._onWinResizeSyncImageViewerClose);
    const w = document.querySelector(".el-image-viewer__wrapper");
    if (w) this.unbindImageViewerClosePosition(w);
  },
  methods: {
    reload: function () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    syncImageViewerClosePosition(wrapper) {
      if (!wrapper || !wrapper.isConnected) return;
      const img = wrapper.querySelector(".el-image-viewer__img");
      const btn = wrapper.querySelector(".el-image-viewer__close");
      if (!img || !btn) return;
      if (!wrapper.isConnected || !img.isConnected) return;
      const ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      const wr = wrapper.getBoundingClientRect();
      const inset = 8;
      const bw = btn.offsetWidth || 32;
      btn.style.right = "auto";
      btn.style.left = `${Math.round(ir.right - wr.left - bw - inset)}px`;
      btn.style.top = `${Math.round(ir.top - wr.top + inset)}px`;
    },
    bindImageViewerClosePosition(wrapper) {
      if (!wrapper || wrapper._imageViewerCloseBound) return;
      const img = wrapper.querySelector(".el-image-viewer__img");
      const btn = wrapper.querySelector(".el-image-viewer__close");
      if (!img || !btn) return;
      wrapper._imageViewerCloseBound = true;
      const sync = () => this.syncImageViewerClosePosition(wrapper);
      wrapper._imageViewerCloseSync = sync;
      img.addEventListener("load", sync);
      requestAnimationFrame(sync);
      requestAnimationFrame(() => requestAnimationFrame(sync));
      wrapper.addEventListener("wheel", sync, { passive: true });
      wrapper.addEventListener("mouseup", sync);
      wrapper.addEventListener("touchend", sync);
      document.addEventListener("mouseup", sync);
      const deb = () => {
        if (wrapper._imageViewerCloseDeb) clearTimeout(wrapper._imageViewerCloseDeb);
        wrapper._imageViewerCloseDeb = setTimeout(sync, 40);
      };
      wrapper._imageViewerImgMo = new MutationObserver(deb);
      wrapper._imageViewerImgMo.observe(img, {
        attributes: true,
        attributeFilter: ["style"],
      });
    },
    unbindImageViewerClosePosition(wrapper) {
      if (!wrapper || !wrapper._imageViewerCloseBound) return;
      wrapper._imageViewerCloseBound = false;
      const img = wrapper.querySelector(".el-image-viewer__img");
      const btn = wrapper.querySelector(".el-image-viewer__close");
      if (img && wrapper._imageViewerCloseSync) {
        img.removeEventListener("load", wrapper._imageViewerCloseSync);
      }
      if (wrapper._imageViewerCloseSync) {
        wrapper.removeEventListener("wheel", wrapper._imageViewerCloseSync);
        wrapper.removeEventListener("mouseup", wrapper._imageViewerCloseSync);
        wrapper.removeEventListener("touchend", wrapper._imageViewerCloseSync);
        document.removeEventListener("mouseup", wrapper._imageViewerCloseSync);
      }
      if (wrapper._imageViewerImgMo) {
        wrapper._imageViewerImgMo.disconnect();
        wrapper._imageViewerImgMo = null;
      }
      if (wrapper._imageViewerCloseDeb) {
        clearTimeout(wrapper._imageViewerCloseDeb);
        wrapper._imageViewerCloseDeb = null;
      }
      if (btn) {
        btn.style.left = "";
        btn.style.top = "";
        btn.style.right = "";
      }
      wrapper._imageViewerCloseSync = null;
    },
  },
}
</script>

<style>
	/* 将默认的Element UI图标类名转变为隐藏 */
	.jtq_list .el-tree .el-icon-caret-right::before,
	.jtq_list .el-tree .el-icon-caret-bottom::before {
	  content: none;
	}

	.jtq_list .el-tree-node__content{
		margin: 5px 0;
	}
	#formBox .el-input-number__increase,#formBox .el-input-number__decrease{
		height: 32px!important;
		line-height: 32px!important;;
	}

	.el-tree .el-tree-node__expand-icon.is-leaf {
	    display: none;
	}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
 .el-table thead{
	height: 40px!important;
 }
 .el-dialog .el-dialog__body .el-form-item {
     margin-bottom: 25px;
 }
 .el-form-item--mini .el-form-item__error {
     padding-top: 8px;
 }
 .el-form-item.is-validating .el-input__inner, .el-form-item.is-validating .el-input__inner:focus, .el-form-item.is-validating .el-textarea__inner,.el-form-item.is-validating .el-textarea__inner:focus{
	 border-color: #F56C6C;
 }
 .el-image-viewer__img{
 	  max-width: 50%!important;
 	  max-height: 50%!important;;
 	  width: auto!important;;
 	  height: auto!important;;
 }
 /* el-image 大图预览关闭按钮位置由 App.vue 中 syncImageViewerClosePosition 按图片实际包围盒计算 */
 .el-image-viewer__wrapper .el-image-viewer__close {
 	  width: 32px !important;
 	  height: 32px !important;
 	  font-size: 18px !important;
 }

 .el-table__body tr.current-row>td{
 	  background-color: #4E77FF!important;
	  color: #fff;
 }
 .el-table{
	 font-size: 12px!important;
 }
 #tagForm.el-form .el-input{
 	  height: auto!important
 }
 .quill-editor{
	height: 200px;
	display: flex;
	flex-direction: column;
}
.ql-toolbar.ql-snow .ql-formats{
	margin-right: 0!important;
}
.ql-snow .ql-picker-label{
	display: flex!important;;
}
 #table2{
	   width: 800px
   }
  #table2 .el-date-editor--time-select .el-input__inner{
	  width: 220px!important;
  }
   #table2 .el-textarea{
	  width: 700px!important;
  }
	.el-dialog .el-dialog__body .el-form-item .el-form-item__content{
		  margin-right: 20px!important;
	}

	#zsForm .el-form-item__content{
		display: block!important
	}
  .avatar-uploader .el-upload {
    height:100%
  }
  .huawei_label .el-form-item__label {
    color: #F56C6C!important
  }

  .container-content .table-header2 .el-input--suffix {
    width: 145px !important
  }
</style>



// WEBPACK FOOTER //
// src/App.vue